import { useRegionUsers, useUnassignUserRegion } from '@/features/region/hooks'

interface RegionUserListProps {
  code: string
}

export function RegionUserList({ code }: RegionUserListProps) {
  const { data: users, isLoading } = useRegionUsers(code)
  const unassign = useUnassignUserRegion()

  if (isLoading) return <div className="text-xs text-slate-400">Ładowanie…</div>
  if (!users || users.length === 0) {
    return <div className="text-xs italic text-slate-400">Brak przypisanych handlowców.</div>
  }

  return (
    <ul className="divide-y">
      {users.map((u) => (
        <li key={u.id} className="flex items-center justify-between py-1.5 text-sm">
          <span>{u.fullName || `#${u.id}`}</span>
          <button
            type="button"
            onClick={() => unassign.mutate(u.id)}
            disabled={unassign.isPending}
            className="text-xs text-red-600 hover:underline disabled:opacity-50"
          >
            Usuń
          </button>
        </li>
      ))}
    </ul>
  )
}
